import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, POST } from '../../Services/AxiosService';
import { CustomStringify } from "../../Helpers/CustomStringify";

export const fetchDataSLRep = createAsyncThunk(
    'SaleReportData/fetchDataSLRep',
    async ({ cmpdetail, UserDetail, FromDate, ToDate }, { rejectWithValue }) => {

        try {
            const result = await GET(`/sr/vendordesignsalerpt/${cmpdetail?.key}/${encodeURIComponent(UserDetail?.result?.user?.company_name)}?from=${FromDate ? FromDate : ""}&to=${ToDate ? ToDate : ""}`);
            return result;
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message || error?.message)
        }
    }
);

const SaleReportDataSlice = createSlice({
    name: 'SaleReportData',
    initialState: {
        result: [],
        status: 'idle',
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchDataSLRep.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchDataSLRep.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.result = action.payload;
            })
            .addCase(fetchDataSLRep.rejected, (state, action) => {
                state.status = 'failed';
                state.result = [];
                state.error = action.payload;
            });
    },
});

export default SaleReportDataSlice.reducer;